import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ErrorInfo, RenderingState } from 'redux/types';
import { RootState } from 'redux/root-reducer';

const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const listSectionsSlice = createSlice({
  name: 'LIST_SECTIONS',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error = initialState.error;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetToInitials: (state) => {
      state.isLoading = initialState.isLoading;
      state.success = initialState.success;
      state.error = initialState.error;
    },
  },
});

// REDUCER
export default listSectionsSlice.reducer;

// ACTIONS
export const { loading, success, failure, resetToInitials } = listSectionsSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.organization.sections.list.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.organization.sections.list.success;
export const selectError = (state: RootState) =>
  state.ui.organization.sections.list.error;
